// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__Sogi7","closeButton":"Tooltip_closeButton__aB-sZ"};